module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Three fishers went sailing out into the West,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Out into the West as the sun went down;")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Each thought on the woman who lov’d him the best")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And the children stood watching them out of the town …")]), _vm._v(" "), _c('p', {
    staticClass: "centerj"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HARLES")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("INGSLEY")]), _vm._v(", ‘T"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HREE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("ISHERS")]), _vm._v("’ (1851)")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("Dusk off the Foreland – the last light going")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And the traffic crowding through,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And five damned trawlers with their sirens blowing Heading the whole review!")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Sweep completed in the fairway.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("No more mines remain.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Send back "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unity")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Claribel")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Assyrian")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stormcock")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Golden Gain")]), _vm._v("’.")]), _vm._v(" "), _c('p', {
    staticClass: "centerj"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("UDYARD")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("IPLING")]), _vm._v(", ‘M"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("INESWEEPERS")]), _vm._v("’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("ONGS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("FROM")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("OOKS")])]), _vm._v(",1914)")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("She’d a gun at her bow that was Newcastle’s best,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And a gun at her stern that was fresh from the Clyde,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And a secret her skipper had never confessed, Not even at dawn, to his newly wed bride;")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And a wireless that whispered above like a gnome, The laughter of London, the boasts of Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("O, it may have been mermaids that lured her from home,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("But nobody knew where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kilmeny")]), _vm._v(" had been.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("It was dark when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kilmeny")]), _vm._v(" came home from her quest,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("With her bridge dabbled red where her skipper had died;")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("But she moved like a bride with a rose at her breast;")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And ‘Well done, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kilmeny")]), _vm._v("!’ the admiral cried.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Now at sixty-four fathom a conger may come,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And nose at the bones of a drowned submarine;")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("But late in the evening "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kilmeny")]), _vm._v(" came home,")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("And nobody knew where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kilmeny")]), _vm._v(" had been.")]), _vm._v(" "), _c('p', {
    staticClass: "centerj"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("LFRED")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("OYES")]), _vm._v(", ‘K"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("ILMENY")]), _vm._v(" – A S"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("ONG")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("OF THE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RAWLERS")]), _vm._v("’ (1917)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p008_01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Syringa")]), _vm._v(" was a ‘Tree’-class Admiralty trawler purchased in 1935, previously named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cape Kanin")]), _vm._v(" and sold back into trade in 1947 as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Davaar Island")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a297ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Frontmatter02.vue
// module id = 72
// module chunks = 0